// extracted by mini-css-extract-plugin
module.exports = {"silver":"#878787","black":"#212121","light-teal":"#6BC1B6","activePageTab":"PageTab_activePageTab__qce9g","pageTab":"PageTab_pageTab__3gpfV"};